<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeBranchOfficeBankAccount(branchOfficeBankAccountToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>
                <v-card dark color="secondary">
                    <v-card-title>Branch Office</v-card-title>
                </v-card>
                <v-progress-linear class="branch-office-bank-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>

                <v-autocomplete
                        :items="customerBranchOffices"
                        item-text="name"
                        item-value="id"
                        label="Select Branch Office"
                        v-model="selectedBranchOffice"
                        required
                ></v-autocomplete>
            </v-flex>
        </v-layout>

        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>


                <v-flex xs12>
                    <v-card dark color="secondary">
                        <v-card-title>Bank Accounts</v-card-title>
                    </v-card>
                    <v-progress-linear class="branch-office-bank-loading" :active="loading"
                                       :indeterminate="true"></v-progress-linear>
                </v-flex>


                <v-list class="branchOfficesBankList" two-line subheader>

                    <template v-for="(item, index) in branchOfficeBankAccounts">
                        <v-list-tile avatar
                                     @click="editItem(index)">
                            <v-list-tile-avatar>
                                <v-icon>account_circle</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>{{item.iban}} - {{item.bic}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon ripple @click="showDeleteDialog(index)">
                                    <v-icon color="red lighten-1">delete</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </template>
                </v-list>
                <v-flex v-if="branchOfficeBankAccounts == null || branchOfficeBankAccounts.length <= 0">
                    <v-card-text><p class="text-xs-center grey--text">No Contact Persons yet</p></v-card-text>
                </v-flex>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="addButtonDisabled" mt-5 class="secondary white--text"
                           @click="addNewBankAccount">Add
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>

            <v-flex xs12 md7 ma-2>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card dark color="secondary">
                            <v-card-title>Edit/Add Bank Account</v-card-title>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md4 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeBankAccount.name"
                                      label="Bank Name"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeBankAccount.iban"
                                      label="IBAN"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeBankAccount.bic"
                                      label="Bic/Swift"></v-text-field>
                    </v-flex>

                </v-layout>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                           @click.native="saveBankAccounts(4)">Save
                        <v-icon class="white--text" right>save</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>
        </v-layout>

    </div>
</template>

<script>
    import {
        Settings,
        Customer,
        CustomerBranchOffice,
        CustomerBranchOfficeBankAccounts
    } from '../../store/namespace-helper'

    export default {
      name: 'bank-accounts',
      data () {
        return {
          isVisible: false,
          removeDialog: false,
          branchOfficeBankAccountToDelete: null,
          onDismissed: false,
          contactPersonsUpdated: 0,
          selectedBranchOffice: null
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              this.loadBranchOffices()
            } else {
              this.branchOfficeUpdated = 0
            }
          }
        },
        loadBranchOffices () {
          this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedCustomer.id)
        },
        loadCustomerBankAccounts () {
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.loadBranchOfficeBankAccounts, this.selectedBranchOffice)
        },
        editItem (index) {
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.setSelectedBranchOfficeBankAccount, this.branchOfficeBankAccounts[index])
        },
        showDeleteDialog (index) {
          this.removeDialog = true
          this.branchOfficeBankAccountToDelete = index
        },
        removeBranchOfficeBankAccount (index) {
          this.removeDialog = false
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.removeBranchOfficeBankAccount, this.branchOfficeBankAccountToDelete)
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.removeBranchOfficeBankAccount, this.branchOfficeBankAccountToDelete)
          this.contactPersonsUpdated = 0
        },
        addNewBankAccount () {
          let bankAccount = {
            id: 0,
            name: 'Bank Name',
            iban: '',
            bic: '',
            customers_branch_offices_id: this.selectedBranchOffice
          }
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.addNewBranchOfficeBankAccount, bankAccount)
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.setSelectedBranchOfficeBankAccount, bankAccount)
        },
        saveBankAccounts (index) {
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.saveBranchOfficeBankAccounts, this.branchOfficeBankAccounts)
          this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.setSelectedBranchOfficeBankAccount, null)
          this.contactPersonsUpdated = 0
        }

      },
      computed: {
        selectedCustomer () {
          return this.$store.getters[Customer.getters.getSelectedCustomer]
        },
        customerBranchOffices () {
          if (this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices] == null) {
            return []
          }
          return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
        },
        branchOfficeBankAccounts () {
          return this.$store.getters[CustomerBranchOfficeBankAccounts.getters.getBranchOfficeBankAccounts]
        },
        getSelectedBranchOfficeBankAccount () {
          return this.$store.getters[CustomerBranchOfficeBankAccounts.getters.getSelectedBranchOfficeBankAccount]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          return this.contactPersonsUpdated < 2
        },
        addButtonDisabled () {
          return this.selectedBranchOffice === null
        },
        formDisabled () {
          return this.getSelectedBranchOfficeBankAccount.id === null
        }

      },
      watch: {
        branchOfficeBankAccounts: {
          handler (val) {
            console.log('branchOfficeContacts data changed: ' + JSON.stringify(val))
            this.contactPersonsUpdated++
          },
          deep: true
        },
        selectedBranchOffice: {
          handler (val) {
            console.log('selectedBranchOffice data changed: ' + JSON.stringify(val))
            this.loadCustomerBankAccounts()
            this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.setSelectedBranchOfficeBankAccount, null)
            this.contactPersonsUpdated = 0
          },
          deep: true
        }
      }
    }
</script>

<style scoped>


    .branchOfficesBankList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesBankList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-bank-loading {
        margin-top: 0px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerBankAccounts.vue